/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsFeedListResponse } from '../../models/news-feed-list-response';

export interface GetNewsFeedForProfile$Params {
  id: number;
  page: number;
  limit: number;
}

export function getNewsFeedForProfile(http: HttpClient, rootUrl: string, params: GetNewsFeedForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListResponse>> {
  const rb = new RequestBuilder(rootUrl, getNewsFeedForProfile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('page', params.page, {});
    rb.path('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsFeedListResponse>;
    })
  );
}

getNewsFeedForProfile.PATH = '/rest/newsfeed/profile/{id}/{page}/{limit}';
